import PageHeader from 'src/components/PageHeader';
import WhiteBoard from 'src/components/WhiteBoard';
import { Formik, Form } from "formik";
import FormikField from "src/components/FormikField/FormikField";
import TwinButton from 'src/components/TwinButton';
import { useContext, useEffect, useState } from 'react';
import { notify } from 'src/services/Notification/Notification';
import { post } from 'src/services/HttpClient';
import { getData } from 'src/actions/getData';
import shopContext from 'src/context/shopContext';
import Skeleton from 'react-loading-skeleton';
import { numberWithCommas } from 'src/utils/thousandSeprator';
import { RxExternalLink } from "react-icons/rx";
import moment from 'jalali-moment';

const SNAPP_SHOP = {
    first_name: "snapp",
    last_name: "shop",
    email: "snapp@bodoroj.com",
    phone: "02100000000",
    city: "تهران",
    state: "تهران",
    address_1: "Tehran-snapp",
    isPaid: true,
    discount: false,
    payment_method: "cheque",
    shipping_id: "flat_rate",
    shipping_total: "0"
}

const TAPSI_SHOP = {
    first_name: "tapsi",
    last_name: "shop",
    email: "tapsi@bodoroj.com",
    phone: "02100000000",
    city: "تهران",
    state: "تهران",
    address_1: "Tehran-tapsi",
    isPaid: true,
    discount: false,
    payment_method: "cheque",
    shipping_id: "flat_rate",
    shipping_total: "0"
}

const DIGIFY = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    address_1: "",
    isPaid: true,
    discount: false,
    payment_method: "cheque",
    shipping_id: "flat_rate",
    shipping_total: "0"
}

export default function AddOrder() {
    const [isLoading, setIsLoading] = useState(false)
    const { products, setProducts } = useContext(shopContext)
    const [coupons, setCoupons] = useState()
    const [paymentGateways, setPaymentGateways] = useState()
    const [shippingMethods, setShippingMethods] = useState()
    const [productOptions, setProductOptions] = useState()
    const [couponOptions, setCouponOptions] = useState()
    const [shippingMethodOptions, setShippingMethodOptions] = useState()
    const [paymentGatewaysOptions, setPaymentGatewaysOptions] = useState()
    const [selectedItems, setSelectedItems] = useState()
    const [selectedCoupon, setSelectedCoupon] = useState()
    const [selectedPayment, setSelectedPayment] = useState()
    const [selectedShipping, setSelectedShipping] = useState()

    const [preSet, setPreSet] = useState("tapsi")

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!products) {
            getData(setProducts, "/products", {}, signal);
        }
        getData(setCoupons, "/coupons", {}, signal)
        getData(setShippingMethods, "/shippingMethods", {}, signal)
        getData(setPaymentGateways, "/paymentGateways", {}, signal)

        return () => {
            controller.abort();
        };
    }, [])

    useEffect(() => {
        if (products) {
            setProductOptions(products.map(product => {
                return {
                    ...product,
                    productId: product.id,
                    value: product?.id,
                    label: product?.sku + " - " + product?.name
                }
            }))
        }
    }, [products])

    useEffect(() => {
        if (coupons) {
            setCouponOptions(coupons.map(coupon => {
                return {
                    ...coupon,
                    value: coupon?.code,
                    label: coupon?.code + ` (میزان تخفیف: ${numberWithCommas(parseInt(coupon?.amount))} تومان) ` + `(حداقل سفارش: ${numberWithCommas(parseInt(coupon?.minimum_amount))} تومان) ` + `(معتبر تا: ${coupon?.date_expires ? moment.from(coupon?.date_expires).locale("fa").format("jYYYY/jMM/jDD HH:mm") : "نامشخص"}) `
                }
            }))
        }
    }, [coupons])

    useEffect(() => {
        if (shippingMethods) {
            setShippingMethodOptions(shippingMethods.map(shippingMethod => {
                return {
                    ...shippingMethod,
                    value: shippingMethod?.id,
                    label: shippingMethod?.title
                }
            }))
        }
    }, [shippingMethods])

    useEffect(() => {
        if (paymentGateways) {
            setPaymentGatewaysOptions(paymentGateways.map(paymentGateway => {
                return {
                    ...paymentGateway,
                    value: paymentGateway?.id,
                    label: paymentGateway?.title
                }
            }))
        }
    }, [paymentGateways])

    const updateSeletedItem = (id, key, value) => {
        let updatedItems = selectedItems.filter(item => {
            if (item.id == id) {
                item[key] = value
            }
            return item
        })
        setSelectedItems(updatedItems)
    }

    return (
        <>
            <PageHeader
                title="ایجاد سفارش جدید"
            />
            <WhiteBoard>
                <div className='p-6 border border-gray-100 rounded-xl'>
                    <div className='flex flex-col gap-2 text-center'>
                        <span className='text-xl font-bold'>ایجاد یک سفارش جدید</span>
                        <span className='text-sm '>برای ایجاد یک سفارش جدید موارد زیر را تکمیل کنید</span>
                    </div>
                    <div className='flex flex-col lg:flex-row items-center gap-4 mt-10'>
                        <span>استفاده از پیش‌فرض‌ها:</span>
                        <div className='flex gap-2 bg-gray-100 dark:bg-gray-700 rounded-2xl p-1'>
                            <button
                                className={`${preSet === "tapsi" ? "bg-white dark:bg-gray-900 rounded-xl" : ""} p-1 transition-all ease-in-out duration-300`}
                                onClick={() => { setPreSet("tapsi") }}
                            >
                                تپسی شاپ
                            </button>
                            <button
                                className={`${preSet === "snapp" ? "bg-white dark:bg-gray-900 rounded-xl" : ""} p-1 transition-all ease-in-out duration-300`}
                                onClick={() => { setPreSet("snapp") }}
                            >
                                اسنپ شاپ
                            </button>
                            <button
                                className={`${preSet === "digify" ? "bg-white dark:bg-gray-900 rounded-xl" : ""} p-1 transition-all ease-in-out duration-300`}
                                onClick={() => { setPreSet("digify") }}
                            >
                                دیجی فای
                            </button>
                            <button
                                className={`${preSet === "custom" ? "bg-white dark:bg-gray-900 rounded-xl" : ""} p-1 transition-all ease-in-out duration-300`}
                                onClick={() => { setPreSet("custom") }}
                            >
                                سفارشی
                            </button>
                        </div>
                    </div>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            isPaid: preSet == "snapp" ? SNAPP_SHOP.isPaid : preSet == "tapsi" ? TAPSI_SHOP.isPaid : preSet == "digify" ? DIGIFY.isPaid : false,
                            first_name: preSet == "snapp" ? SNAPP_SHOP.first_name : preSet == "tapsi" ? TAPSI_SHOP.first_name : preSet == "digify" ? DIGIFY.first_name : "",
                            last_name: preSet == "snapp" ? SNAPP_SHOP.last_name : preSet == "tapsi" ? TAPSI_SHOP.last_name : preSet == "digify" ? DIGIFY.last_name : "",
                            email: preSet == "snapp" ? SNAPP_SHOP.email : preSet == "tapsi" ? TAPSI_SHOP.email : preSet == "digify" ? DIGIFY.email : "",
                            phone: preSet == "snapp" ? SNAPP_SHOP.phone : preSet == "tapsi" ? TAPSI_SHOP.phone : preSet == "digify" ? DIGIFY.phone : "",
                            address_1: preSet == "snapp" ? SNAPP_SHOP.address_1 : preSet == "tapsi" ? TAPSI_SHOP.address_1 : preSet == "digify" ? DIGIFY.address_1 : "",
                            state: preSet == "snapp" ? SNAPP_SHOP.state : preSet == "tapsi" ? TAPSI_SHOP.state : preSet == "digify" ? DIGIFY.state : "",
                            city: preSet == "snapp" ? SNAPP_SHOP.city : preSet == "tapsi" ? TAPSI_SHOP.city : preSet == "digify" ? DIGIFY.city : "",
                        }}
                        onSubmit={async (values, { setSubmitting }) => {

                            // if (selectedItems?.filter(item => {
                            //     if (item?.custom_count > item.stock_quantity) {
                            //         return true
                            //     }
                            // })?.length) {
                            //     notify("تعداد در سفارش نمی‌تواند از موجودی کالا بزرگتر باشد", "error")
                            //     return
                            // }

                            if (!selectedItems?.length) {
                                notify("سبد انتخابی شما خالی است", "error")
                                return
                            }

                            // if (selectedItems?.filter(item => {
                            //     if (item.stock_status == "outofstock") {
                            //         return true
                            //     }
                            // })?.length) {
                            //     notify("اقلامی در سفارش شما ناموجود هستند", "error")
                            //     return
                            // }

                            setIsLoading(true)
                            let result = await post("/orders", {
                                "payment_method": selectedPayment?.id,
                                // "payment_method_title": selectedPayment?.title,
                                "set_paid": values.isPaid,
                                "billing": {
                                    "first_name": values.first_name,
                                    "last_name": values.last_name,
                                    "address_1": values.address_1,
                                    "city": values.city,
                                    "state": values.state,
                                    "country": "IRAN",
                                    "email": values.email,
                                    "phone": values.phone
                                },
                                "shipping": {
                                    "first_name": values.first_name,
                                    "last_name": values.last_name,
                                    "address_1": values.address_1,
                                    "city": values.city,
                                    "state": values.state,
                                    "country": "IRAN",
                                    "email": values.email,
                                    "phone": values.phone
                                },
                                "line_items": selectedItems ? selectedItems.map(item => {
                                    let quantity = item?.custom_count ? parseInt(item?.custom_count) : 1
                                    return {
                                        "product_id": parseInt(item?.id),
                                        "quantity": quantity,
                                        "total": item?.custom_price ? (item?.custom_price * quantity).toString() : (item?.regular_price * quantity).toString(),
                                        "subtotal": item?.custom_price ? (item?.custom_price * quantity).toString() : (item?.regular_price * quantity).toString(),
                                        "meta_data": [
                                            {
                                                "key": "_regular_price",
                                                "value": parseInt(item?.custom_price) > parseInt(item?.regular_price) ? (item?.custom_price).toString() : (item?.regular_price).toString()
                                            }
                                        ]
                                    }
                                }) : [],
                                "shipping_lines": selectedShipping ? [
                                    {
                                        "method_id": selectedShipping?.id,
                                        "total": values?.shippingTotal
                                    }
                                ] : [],
                                "coupon_lines": values.coupon ? [
                                    {
                                        "code": values.coupon
                                    }
                                ] : []
                            })
                            notify(result.message)
                            setIsLoading(false)
                        }}
                    >
                        {({ values, errors, touched, setFieldValue }) => (
                            <Form>
                                <div className="flex flex-col bg-white dark:bg-black rounded-2xl">
                                    <div className="flex flex-col gap-5 mt-10">
                                        <div className="flex flex-col xl:grid gap-5 gap-y-7 grid-cols-2  w-full justify-center">
                                            <FormikField
                                                inputName="first_name"
                                                label="نام"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="نام سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <FormikField
                                                inputName="last_name"
                                                label="نام خانوادگی"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="نام خانوادگی سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <FormikField
                                                inputName="email"
                                                label="ایمیل"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="ایمیل سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <FormikField
                                                inputName="phone"
                                                label="شماره تماس"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="شماره تماس سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <FormikField
                                                inputName="state"
                                                label="استان"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="استان سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <FormikField
                                                inputName="city"
                                                label="شهر"
                                                disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                placeholder="شهر سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                errors={errors}
                                            />
                                            <div className='flex flex-col gap-10 col-span-full'>
                                                <FormikField
                                                    inputName="address_1"
                                                    label="آدرس"
                                                    disabled={((preSet != "custom") && (preSet != "digify")) ? true : false}
                                                    placeholder="آدرس سفارش دهنده را وارد کنید..."
                                                    // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                    errors={errors}
                                                />
                                                <FormikField
                                                    type='checkbox'
                                                    errors={errors}
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    inputName="isPaid"
                                                    label="پرداخت شده"
                                                    placeholder="نام سفارش دهنده را وارد کنید..."
                                                // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex flex-col bg-gray-50 dark:bg-gray-800 rounded-xl mt-10 p-5'>
                                        <span>
                                            + افزودن اقلام سفارش
                                        </span>
                                        {
                                            products
                                                ?
                                                <FormikField
                                                    inputName="items"
                                                    type="multiselect"
                                                    info="محصولات مورد نظر خود را اضافه کنید"
                                                    errors={errors}
                                                    values={values}
                                                    setFieldValue={setFieldValue}
                                                    placeholder="محصولاتی که در سفارش هستند را انتخاب کنید..."
                                                    options={productOptions}
                                                    additionalAction={(selectedOption) => {
                                                        setSelectedItems(selectedOption)
                                                    }}
                                                />
                                                :
                                                <Skeleton height={50} className="!rounded-xl" />
                                        }
                                        <div className='flex flex-col gap-2'>
                                            {
                                                selectedItems && selectedItems?.map(item => {
                                                    return (
                                                        <div className="p-2 flex items-center justify-between gap-2 w-full border border-gray-200 rounded-xl first:mt-2">
                                                            <div className="flex gap-2 items-center">
                                                                <img className="w-14 border border-gray-100 rounded-xl" src={item?.image} />
                                                                <span className="text-sm">
                                                                    {item?.name} ({item?.sku})
                                                                </span>
                                                                <div className="flex gap-1 items-center text-xs">
                                                                    {
                                                                        item.stock_quantity
                                                                            ?
                                                                            <span className='bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded-lg'>موجودی: {item.stock_quantity} عدد</span>
                                                                            :
                                                                            <span className='bg-red-100 text-red-600 px-2 py-1 rounded-lg'>ناموجود</span>
                                                                    }
                                                                </div>
                                                                <a target="_blank" href={`${item?.permalink}`}>
                                                                    <RxExternalLink size={18} color="blue" />
                                                                </a>
                                                            </div>
                                                            <div className="flex items-center gap-1 mx-2">
                                                                <div className='mx-10 flex gap-1 items-center'>
                                                                    <span className='text-sm'>قیمت سایت: </span>
                                                                    <span className="line-through mx-1">.
                                                                        {item.regular_price}
                                                                    </span>
                                                                    <span className="font-semibold">
                                                                        {item.price}
                                                                    </span>
                                                                    <span className="text-xs">تومان</span>
                                                                </div>
                                                                <div className='flex gap-1 items-center text-sm'>
                                                                    <label>قیمت فروش: </label>
                                                                    <input
                                                                        onChange={(event) => { updateSeletedItem(item.id, "custom_price", event?.target?.value) }}
                                                                        value={item?.["custom_price"] ? item?.["custom_price"] : item?.["regular_price"]}
                                                                        className='border border-gray-200 rounded-lg p-2'
                                                                        type="text"
                                                                        placeholder='به تومان وارد کنید'
                                                                        onBlur={(event) => {
                                                                            if (parseInt(item?.["regular_price"]) < parseInt(event?.target?.value)) {
                                                                                notify("قیمت وارد شده بالاتر از قیمت مصرف کننده است، مطمئن شوید که اشتباهی رخ نداده است", "error")
                                                                            }
                                                                            else if ((parseInt(item?.["regular_price"]) / 3) > parseInt(event?.target?.value)) {
                                                                                notify("قیمت را خیلی پایین وارد کرده‌اید، مطمئن شوید که اشتباهی رخ نداده است", "error")
                                                                            }
                                                                        }}
                                                                    />
                                                                    <label>تعداد: </label>
                                                                    <input
                                                                        onChange={(event) => { updateSeletedItem(item.id, "custom_count", event?.target?.value) }}
                                                                        value={item?.["custom_count"] ? item?.["custom_count"] : 1}
                                                                        // max={item?.["stock_quantity"]}
                                                                        min={1}
                                                                        className='border border-gray-200 rounded-lg p-2 w-12'
                                                                        type="number"
                                                                        onBlur={(event) => {
                                                                            if (parseInt(item?.["stock_quantity"]) < parseInt(event?.target?.value)) {
                                                                                notify("تعداد وارد شده بیشتر از موجودی است، مطمئن شوید که اشتباهی رخ نداده است", "error")
                                                                            }
                                                                        }}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    {
                                        preSet == "custom"
                                        &&
                                        <div className='flex flex-col bg-gray-50 dark:bg-gray-800 rounded-xl mt-4 p-5'>
                                            <span>
                                                + افزودن کد تخفیف
                                            </span>
                                            {
                                                coupons
                                                    ?
                                                    <FormikField
                                                        inputName="coupon"
                                                        type="select"
                                                        info="تنها قادر به انتخاب یک کد تخفیف هستید"
                                                        errors={errors}
                                                        values={values}
                                                        setFieldValue={setFieldValue}
                                                        options={couponOptions}
                                                        placeholder="در صورتی که نیاز به افزودن کد تخفیف به سفارش خود دارید ازین قسمت انتخاب کنید..."
                                                        additionalAction={(selectedOption) => {
                                                            setSelectedCoupon(selectedOption)
                                                        }}
                                                    />
                                                    :
                                                    <Skeleton height={50} className="!rounded-xl" />
                                            }
                                        </div>
                                    }
                                    {
                                        preSet == "custom"
                                        &&
                                        <div className='flex flex-col bg-gray-50 dark:bg-gray-800 rounded-xl mt-4 p-5'>
                                            <span>
                                                + افزودن روش پرداخت
                                            </span>
                                            {
                                                shippingMethods
                                                    ?
                                                    <FormikField
                                                        inputName="payment"
                                                        type="select"
                                                        info="روش پرداخت مناسب سفارش را انتخاب کنید"
                                                        errors={errors}
                                                        values={values}
                                                        setFieldValue={setFieldValue}
                                                        options={paymentGatewaysOptions}
                                                        placeholder="روش پرداخت مورد نظر خود را انتخاب کنید..."
                                                        additionalAction={(selectedOption) => {
                                                            setSelectedPayment(selectedOption)
                                                        }}
                                                    />
                                                    :
                                                    <Skeleton height={50} className="!rounded-xl" />
                                            }
                                        </div>
                                    }
                                    {
                                        preSet == "custom"
                                        &&
                                        <div className='flex flex-col lg:flex-row gap-5 bg-gray-50 dark:bg-gray-800 rounded-xl mt-4 p-5 w-full'>
                                            <div className='flex flex-col w-full'>
                                                <span>
                                                    + افزودن روش ارسال
                                                </span>
                                                {
                                                    shippingMethods
                                                        ?
                                                        <FormikField
                                                            inputName="shipping"
                                                            type="select"
                                                            info="روش ارسال مناسب سفارش را انتخاب کنید"
                                                            errors={errors}
                                                            values={values}
                                                            setFieldValue={setFieldValue}
                                                            options={shippingMethodOptions}
                                                            placeholder="روش ارسال مورد نظر خود را انتخاب کنید..."
                                                            additionalAction={(selectedOption) => {
                                                                setSelectedShipping(selectedOption)
                                                            }}
                                                        />
                                                        :
                                                        <Skeleton height={50} className="!rounded-xl" />
                                                }
                                            </div>
                                            <div className='flex flex-col w-full'>
                                                <span>
                                                    + هزینه ارسال
                                                </span>
                                                {
                                                    shippingMethods
                                                        ?
                                                        <FormikField
                                                            inputName="shippingTotal"
                                                            errors={errors}
                                                            placeholder="مبلغ ارسال را وارد کنید..."
                                                        />
                                                        :
                                                        <Skeleton height={50} className="!rounded-xl" />
                                                }
                                            </div>
                                        </div>
                                    }

                                    <TwinButton
                                        acceptTitle='ثبت سفارش'
                                        isLoading={isLoading}
                                        rejectTitle={false}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </WhiteBoard>
        </>
    )
}
